module.exports = __webpack_public_path__ + "img/profile.d5ff69e1.jpg";